import React from 'react';

import { Input } from '@eliadmin/core/src/components/ui/input';
import { Slider } from '@eliadmin/core/src/components/ui/slider';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function AttributePrice() {
  const max = useCategoryStore(state => state.category.price.max);
  const min = useCategoryStore(state => state.category.price.min) ?? 0;
  const clearTrigger = useCategoryStore(state => state.clearTrigger);
  const [priceRange, setPriceRange] = React.useState<number[]>([min ?? 0, max ?? 100000]);
  const generalLayout = useGlobalStore(s => s.generalLayout);
  const currency = generalLayout.currency;

  const setFilter = useCategoryStore(state => state.setFilter);

  React.useEffect(() => {
    setPriceRange([min ?? 0, max ?? 100000]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTrigger]);

  const handlePriceChange = () => {
    setFilter({ price_min: priceRange[0], price_max: priceRange[1] });
  };

  if (max === null) return null;

  return (
    <div className={cn('flex flex-col gap-5 py-2', 'ea-attribute-price')}>
      <div className="w-full px-3 py-0.5">
        <Slider
          isDual
          value={priceRange}
          min={min}
          max={max}
          aria-label="Price range"
          onValueChange={value => setPriceRange(value)}
          onBlur={handlePriceChange}
          className=""
        />
      </div>
      <div className={cn('grid w-full grid-cols-2 gap-3', 'ea-attribute-price__wrapper')}>
        <Input
          className={{
            wrapper: cn('col-span-1 flex-1 rounded-[20px] border', 'ea-attribute-radio__input-min'),
            main: cn('rounded-[20px] bg-transparent px-4 text-black'),
          }}
          name={'min'}
          value={priceRange[0]}
          disabled
          after={<span className="pr-4 font-medium">{currency}</span>}
        />
        <Input
          className={{
            wrapper: cn('col-span-1 flex-1 rounded-[20px] border', 'ea-attribute-radio__input-max'),
            main: cn('rounded-[20px] bg-transparent px-4 text-black'),
          }}
          name={'max'}
          value={priceRange[1]}
          disabled
          after={<span className="pr-4 font-medium">{currency}</span>}
        />
      </div>
    </div>
  );
}
